import { ECurrency } from '@lbs/currency'
import { Box, Chip } from '@mui/material'
import { MRT_ColumnDef } from 'material-react-table'
import { IPlayerFinance } from '../../api/players'
import { formatToMoscowTZ } from '../../utils/date'
import { moneyFormat } from '../../utils/money'
import { Currency } from '../index'
import { TransactionDetailsCell } from './detailsFormatter'
import { EFinanceReason, FINANCE_REASON_LABELS } from './types'

export const createColumns = (currency: ECurrency): MRT_ColumnDef<IPlayerFinance>[] => [
  {
    id: 'createdAt',
    accessorFn: (row) => new Date(row.createdAt),
    header: 'Дата и время',
    sortingFn: 'datetime',
    sortDescFirst: true,
    enableColumnFilter: false,
    enableSorting: false,
    size: 180,
    Cell: ({ cell }) => (
      <Box sx={{ whiteSpace: 'nowrap', fontFamily: 'monospace', fontSize: '0.875rem' }}>
        {formatToMoscowTZ(cell.getValue<Date>())}
      </Box>
    ),
  },
  {
    id: 'reason',
    accessorKey: 'reason',
    header: 'Тип операции',
    enableSorting: false,
    filterVariant: 'multi-select',
    filterSelectOptions: Object.entries(FINANCE_REASON_LABELS).map(([value, label]) => ({
      text: label,
      value,
    })),
    size: 180,
    Cell: ({ cell }) => {
      const reason = cell.getValue<string>() as EFinanceReason
      const label = FINANCE_REASON_LABELS[reason] || reason

      // Цвета для разных типов операций
      const colorMap: Record<EFinanceReason, 'success' | 'error' | 'warning' | 'info' | 'default'> = {
        [EFinanceReason.CREDIT]: 'success',
        [EFinanceReason.GIFT]: 'success',
        [EFinanceReason.DROP]: 'error',
        [EFinanceReason.ROLLBACK]: 'warning',
        [EFinanceReason.SETTLE]: 'info',
        [EFinanceReason.OPENING_BALANCE]: 'default',
      }

      return <Chip label={label} color={colorMap[reason] || 'default'} size="small" variant="outlined" />
    },
  },
  {
    id: 'amount',
    accessorFn: (row) => Number(row.amount),
    header: 'Сумма операции',
    enableColumnFilter: false,
    enableSorting: false,
    size: 150,
    Cell: ({ cell }) => {
      const value = cell.getValue<number>()
      const isPositive = value > 0
      return (
        <Box
          sx={{
            fontWeight: 'bold',
            color: isPositive ? 'success.main' : 'error.main',
            fontFamily: 'monospace',
          }}>
          {isPositive ? '+' : ''}
          {moneyFormat(String(value.toFixed(2)))}&nbsp;
          <Currency currency={currency} />
        </Box>
      )
    },
  },
  {
    id: 'details',
    accessorKey: 'details',
    header: 'Детали',
    enableSorting: false,
    enableColumnFilter: false,
    size: 250,
    Cell: ({ row }) => {
      const { details, refId } = row.original
      return <TransactionDetailsCell details={details} refId={refId} />
    },
  },
  // {
  //   id: 'balanceBefore',
  //   accessorFn: (row) => Number(row.balanceBefore),
  //   header: 'Баланс до операции',
  //   enableColumnFilter: false,
  //   enableSorting: false,
  //   size: 150,
  //   Cell: ({ cell }) => {
  //     const value = cell.getValue<number>()
  //     return (
  //       <Box sx={{ fontFamily: 'monospace', color: 'text.secondary' }}>
  //         {moneyFormat(String(value.toFixed(2)))}&nbsp;
  //         <Currency currency={currency} />
  //       </Box>
  //     )
  //   },
  // },
  // {
  //   id: 'balanceAfter',
  //   accessorFn: (row) => Number(row.balanceAfter),
  //   header: 'Баланс после операции',
  //   enableColumnFilter: false,
  //   enableSorting: false,
  //   size: 150,
  //   Cell: ({ cell }) => {
  //     const value = cell.getValue<number>()
  //     return (
  //       <Box sx={{ fontFamily: 'monospace', fontWeight: 'medium' }}>
  //         {moneyFormat(String(value.toFixed(2)))}&nbsp;
  //         <Currency currency={currency} />
  //       </Box>
  //     )
  //   },
  // },
]
